// extracted by mini-css-extract-plugin
module.exports = {"btnLoading":"Button_btnLoading__1dR42","spinner":"Button_spinner__3qo6v"};